// only load our form helpers if we have a form on the current page
jQuery(($) => {
    if ($('.js-modal').length) {
        require.ensure([], () => {
            require('script!izimodal/js/iziModal');
            $('.js-modal').iziModal();
        }, 'modal');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/modal.js